export class SizeGuide extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.unitConverter = this.els['unit-converter'].element
    this.unitConverterButtons = this.els['unit-converter-button'].elements

    this.charts = this.els.chart.elements

    this.tabs = this.els.tab.elements
    this.panels = this.els.panel.elements
  }

  setupListeners () {
    super.setupListeners()

    this.handleUnitClick = this.handleUnitClick.bind(this)

    this.unitConverterButtons.forEach((button) => {
      this.listeners.add(button, `click`, this.handleUnitClick)
    })

    this.handleTabClick = this.handleTabClick.bind(this)
    this.tabs.forEach((tab) => {
      this.listeners.add(tab, `click`, this.handleTabClick)
    })
  }

  handleTabClick (e) {
    const tab = e.target.closest(this.els.tab.selector)
    if (!tab) return

    const tabIndex = tab.dataset.index

    this.panels.forEach((panel) =>
      panel.setAttribute(
        'aria-hidden',
        panel.dataset.index === tabIndex ? 'false' : 'true',
      ),
    )

    this.unitConverterButtons.forEach((button) =>
      button.setAttribute(
        'aria-pressed',
        button.dataset.index === tabIndex ? 'true' : 'false',
      ),
    )

    this.tabs.forEach((tab) =>
      tab.setAttribute(
        'aria-pressed',
        tab.dataset.index === tabIndex ? 'true' : 'false',
      ),
    )
  }

  handleUnitClick (e) {
    const button = e.target.closest(this.els['unit-converter-button'].selector)
    if (!button) return

    const buttonIndex = button.dataset.index
    const buttonUnit = button.dataset.unit

    this.unitConverter.dataset.activeIndex = buttonIndex

    this.unitConverterButtons.forEach((button) =>
      button.setAttribute(
        'aria-pressed',
        button.dataset.index === buttonIndex ? 'true' : 'false',
      ),
    )

    this.charts.forEach((chart) =>
      chart.setAttribute(
        'aria-hidden',
        chart.dataset.unit === buttonUnit ? 'false' : 'true',
      ),
    )
  }
}

if (!customElements.get('size-guide')) {
  customElements.define('size-guide', SizeGuide)
}
